module.exports = __webpack_public_path__ + "img/twitter-new.dc2c8a7f.svg";